import React, { useCallback, useEffect, useState } from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import MyTable from '../../components/MyTable';
import useInputState from '../../helpers/hooks/useInputState';
import OperationItem from './components/OperationItem';
import { OPERATION_HEADER_COLUMNS, OPERATION_WIDTHS } from './constants';
import MyButton from '../../components/MyButton';
import AddOrgIcon from '../../assets/formIcons/addOrg.svg';
import Api from '../../Api';
import sendRequest from '../../helpers/sendRequest';

function Operations() {
  const navigate = useNavigate();
  const [operations, setOperations] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useInputState(1);
  const [perPage, setPerPage] = useState(100);
  const [q, setQ] = useInputState();
  const [isInit, setIsInit] = useState(false);
  const [itemsPassed, setItemsPassed] = useState(0);

  const getOperations = async ({ paramsPage, paramsPerPage = perPage, isInitRequired = true }) => {
    if (loading || (isInitRequired && !isInit)) return;

    const data = await sendRequest({
      request: Api.getOperations,
      payload: {
        page: paramsPage,
        per_page: paramsPerPage,
      },
      warnErrorText: 'while getting operations',
      setLoading,
    });

    if (data?.status === 'ok') {
      setOperations(data.operations || []);
      setTotal(data.total || 0);
    }
  };

  const TableItemComponent = useCallback((item, index) => (
    <OperationItem
      key={item._id}
      item={item}
      itemsPassed={itemsPassed}
      widths={OPERATION_WIDTHS}
      index={index}
    />
  ), [itemsPassed]);

  const handlePage = (newVal) => {
    if (newVal === page) return;
    setPage(newVal);
    getOperations({ paramsPage: newVal });
  };

  const onCreateOperationClick = () => {
    navigate('/operations/new-operation');
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);

      if (perPage < 1) {
        setPerPage(1);
        getOperations({ paramsPage: 1, paramsPerPage: 1 });
      } else if (perPage > 500) {
        setPerPage(500);
        getOperations({ paramsPage: 1, paramsPerPage: 500 });
      } else {
        getOperations({ paramsPage: 1 });
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [perPage]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      getOperations({ paramsPage: 1 });
    }, 400);

    return () => clearTimeout(timer);
  }, [q]);

  useEffect(() => {
    getOperations({ paramsPage: page, isInitRequired: false });
    setTimeout(() => {
      setIsInit(true);
    }, 500);
  }, []);

  useEffect(() => {
    setItemsPassed((page - 1) * perPage);
  }, [operations, page, perPage]);

  return (
    <div className="operations">
      <PageTitle
        text="Операции (во всех странах)"
        RightComponent={(
          <MyButton
            text="Новая"
            svgPath={AddOrgIcon}
            className="org_add_btn"
            onClick={onCreateOperationClick}
          />
        )}
      />
      <MyTable
        q={q}
        setQ={setQ}
        perPage={perPage}
        setPerPage={setPerPage}
        headerColumns={OPERATION_HEADER_COLUMNS}
        Item={TableItemComponent}
        data={operations}
        page={page}
        setPage={handlePage}
        total={total}
        isLoading={loading}
        hideSearch
      />
    </div>
  );
}

export default Operations;
